<template>
    <div>
        <template v-if="!devolucion">
            <PageTitle v-if="error" :title="$t('gracias.error_title')"/>
            <PageTitle v-else data-cy="gracias-compra" :title="$t('gracias.title')" sectionClass="buy_success"/>
        </template>
        <template v-else>
            <PageTitle title="¡DEVOLUCIONES!"/>
        </template>

        <FirstBanner/>

        <section class="padding-vertical-content pt-0">
            <div class="container">
                <div class="row justify-content-center" v-if="!devolucion">
                    <div class="col-12 col-lg-10" v-if="error">
                        <div class="text-center">
                            <div class="h5">
                                {{ $t("gracias.error") }}
                            </div>
                            <div>
                                <p>{{ $t("gracias.mas_tarde") }}</p>
                            </div>
                            <router-link :to="{ name: 'front.home' }" class="button effect-button mb-0 mt-3">
                                <span>{{ $t("gracias.volver") }}</span>
                            </router-link>
                        </div>
                    </div>
                    <div class="col-12 col-lg-10" v-else>
                        <template v-if="loading">
                            <div class="row">
                                <div class="col-12 mb-3">
                                    <div class="text-center my-5 h4">
                                        {{ $t("gracias.procesando", { email: manager.email_incidencias ? manager.email_incidencias : "info@compralaentrada.com" }) }}
                                    </div>
                                </div>
                                <div class="col-12" style="margin-bottom: 60px; margin-top: 20px">
                                    <LoaderComponent />
                                </div>
                            </div>
                        </template>
                        <div v-else>
                            <AbonosComponent
                                v-if="es_abono"
                                :es_internacional="es_internacional"
                                :es_lfp="es_lfp"
                                :datos_compradores="datos_compradores"
                            />

                            <EntradasComponent
                                v-if="es_online"
                                :datos_compradores="datos_compradores"
                                :productos="productos"
                                :tpv_order="tpv_order"
                                :datos_online="datos_online"
                                :es_dia_abonado="es_dia_abonado"
                                :total="total"
                                :evento_id="evento_id"
                                :evento_name="evento_name"
                                :url_evento="url_evento"
                                :user_id="user_id"
                                :datos_peticion="datos_peticion"
                                :sesion_fecha="sesion_fecha"
                                :reserva_instalaciones="reserva_instalaciones"
                            />

                            <EntradasCarritoComponent
                                v-if="varios_eventos"
                                :datos_varios_eventos = datos_varios_eventos
                            />

                            <PackComponent
                                v-if="es_pack"
                                :datos_pack="datos_pack"
                            />
                        </div>
                    </div>
                </div>
                <DevolucionComponent
                    v-if="devolucion"
                    :error="error"
                />
            </div>
        </section>
    </div>
</template>

<script>
    import PageTitle from "@/components/frontend/shared/PageTitle";
    import FirstBanner from "@/components/frontend/shared/FirstBanner";
    import LoaderComponent from "@/components/preloader/LoaderComponent";
    import DevolucionComponent from "@/components/frontend/compra/DevolucionComponent.vue";
    import AbonosComponent from '../../../components/frontend/compra/AbonosComponent.vue';
    import EntradasComponent from '../../../components/frontend/compra/EntradasComponent.vue';
    import PackComponent from '../../../components/frontend/compra/PackComponent.vue';
    import EntradasCarritoComponent from "../../../components/frontend/compra/EntradasCarritoComponent.vue";
    import { useEventoTracking } from '@/composables/front/analytics/useEventoTracking';
    import { useAbonoTracking } from '@/composables/front/analytics/useAbonoTracking';

    export default {
        props: ["session_id", "tpv_order"],
        data() {
            return {
                datos_compradores: null,
                productos: null,
                datos_peticion: null,
                es_internacional: null,
                es_abono: null,
                es_online: null,
                es_dia_abonado: null,
                es_lfp: false,
                loading: true,
                error: false,
                devolucion: false,
                evento_id: null,
                evento_name: "",
                evento_date: "",
                total: 0,
                url_evento: "",
                user_id: null,
                es_pack: null,
                datos_pack: null,
                sesion_fecha: null,
                compra_unica: false,
                varios_eventos: null,
                datos_varios_eventos: null,
                reserva_instalaciones: null,
                datos_online: null,
                pollTimer: null,
            };
        },
        created() {
            if (this.session_id == 0 && this.tpv_order == 0) {
                if (this.$route.query.devolucion) {
                    this.devolucion = true;

                    if (this.$route.query.error == "true") {
                        this.error = true;
                    } else {
                        this.error = false;
                    }
                } else {
                    this.error = true;
                }
            } else {
                if (this.$route.query.error == "true") {
                    this.error = true;
                } else {
                    this.getSesion();
                }
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
        
        },
        methods: {
            getSesion: function() {
                if (this.pollTimer) {
                    clearTimeout(this.pollTimer);
                    this.pollTimer = null;
                }

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                    },
                    sesion_id: this.session_id,
                    tpv_order: this.tpv_order,
                };

                this.$store
                    .dispatch(this.config.getVuexAlias("front.sesion.get"), params).then(res => {
                        if (res.data.error) {
                            this.error = true;
                            this.loading = false;
                        } else {
                            if (res.data.response_code != "wait") {
                                if(res.data.es_pack) {
                                    this.es_pack = true;
                                    this.datos_pack = {
                                        pedidos: res.data.pedidos,
                                        pack: res.data.pack
                                    }

                                    this.loading = false;
                                } else if(res.data.varios_eventos) {
                                    this.varios_eventos = true;
                                    this.datos_varios_eventos = {
                                        pedidos: res.data.pedidos,
                                    }

                                    this.loading = false;
                                } else {
                                    this.error = parseInt(res.data.response_code) > 99;

                                    this.datos_compradores = res.data.datos_compradores;
                                    this.es_internacional = res.data.es_internacional;
                                    this.es_abono = res.data.es_abono;
                                    this.es_online = res.data.es_online;
                                    this.es_dia_abonado = res.data.es_dia_abonado;
                                    this.es_lfp = res.data.es_lfp;
                                    this.sesion_fecha = res.data.sesion_fecha;

                                    if (!this.es_abono) {
                                        this.evento_id = res.data.evento_id;
                                        this.evento_name = res.data.evento_name;
                                        this.evento_date = res.data.evento_date;
                                        this.url_evento = res.data.url_evento;
                                        this.user_id = res.data.user_id;
                                        this.datos_peticion = res.data.datos_peticion;
                                        this.reserva_instalaciones = res.data.reserva_instalaciones;
                                        if(res.data.compra_unica) {
                                            this.compra_unica = true;   
                                        }
                                        this.productos = res.data.productos;

                                        this.$store.commit('setFrontEvents', null);
                                        this.$store.commit('setFrontExperiencias', null);
                                    }

                                    if (this.datos_compradores?.length > 0) {
                                        this.datos_compradores.forEach(datos_comprador => {
                                            this.total += parseFloat(datos_comprador.precio);
                                        });
                                    }

                                    if (Array.isArray(this.productos) && this.productos.length > 0) {
                                        this.total += this.productos.reduce((sum, producto) => {
                                            const unidades = parseFloat(producto.unidades) || 0;
                                            const precioBase = parseFloat(producto.price) || 0;
                                            const gastosGestion = Number(producto.price_management_interno) === 0 ? (parseFloat(producto.price_management) || 0) : 0;

                                            return sum + (unidades * (precioBase + gastosGestion));
                                        }, 0);
                                    }

                                    if (this.es_internacional) {
                                        this.datos_compradores[0].nombre =
                                            res.data.datos_internacional.nombre +
                                            " " +
                                            res.data.datos_internacional.apellidos;
                                        this.datos_compradores[0].dni =
                                            res.data.datos_internacional.dni;
                                        this.datos_compradores[0].telefono =
                                            res.data.datos_internacional.telefono;
                                        this.datos_compradores[0].email =
                                            res.data.datos_internacional.email;
                                    }

                                    if (this.es_online) {
                                        this.datos_online = res.data.datos_online;
                                    }

                                    this.loading = false;
                                    this.trackPurchaseGA4();
                                }
                            } else {
                                this.pollTimer = setTimeout(() => {
                                    this.getSesion();
                                }, 10000);
                            }
                        }
                    })
                    .catch(error => {
                        this.error = true;
                        console.log(error);
                        this.cargando_zona = false;
                    });
            },
            trackPurchaseGA4: async function() {
                try {
                    if (this.es_abono) {
                        // ABONO purchase flow
                        const { trackPurchase } = useAbonoTracking({ store: this.$store, getVuexAlias: this.config.getVuexAlias });

                        const abonoResumen = {
                            abono_id: this.lista_abonados ? this.lista_abonados.id : undefined,
                            abono_name: this.lista_abonados ? this.lista_abonados.nombre : undefined,
                            lista_abonados: this.lista_abonados ? [this.lista_abonados] : [],
                            resumen_total: this.total,
                            moneda: 'EUR',
                        };

                        // ASYNC: Call backend guard first, then fire GA4 if needed
                        const wasFired = await trackPurchase(
                            abonoResumen,
                            String(this.tpv_order),
                            String(this.session_id),
                            this.datos_compradores,  // asientos
                            null  // itemsCarrito
                        );

                    } else {
                        // EVENTO purchase flow
                        const { trackPurchase } = useEventoTracking({ store: this.$store, getVuexAlias: this.config.getVuexAlias });

                        const resumen = {
                            evento_id: this.evento_id || (this.lista_abonados ? this.lista_abonados.id : undefined),
                            evento_name: this.evento_name || (this.lista_abonados ? this.lista_abonados.nombre : undefined),
                            datos_compradores: this.datos_compradores,
                            productos: this.productos || [],
                            total_price: this.total,
                        };

                        // ASYNC: Call backend guard first, then fire GA4 if needed
                        const wasFired = await trackPurchase(
                            resumen,
                            String(this.tpv_order),
                            String(this.session_id)
                        );

                    }
                } catch (err) {
                    console.error('[CompraFinalizada] GA4 tracking failed:', err);
                }
            },
        },
        beforeDestroy() {
            if (this.pollTimer) {
                clearTimeout(this.pollTimer);
                this.pollTimer = null;
            }
        },
        destroyed() {
            if (this.compra_unica) {
                localStorage.removeItem('client_session_id');
            }
        },
        components: {
            PageTitle, FirstBanner, LoaderComponent,
            DevolucionComponent, AbonosComponent, EntradasComponent, PackComponent, EntradasCarritoComponent
        },
    };
</script>
